<template>
  <div class="cf-node-properties__hours-filter-breaks">
    <strong>Breaks</strong>
    <ul>
      <li
        v-for="(b, index) in breaks"
        :key="index"
      >
        {{ breakStartTime(b.startTime.hour, b.startTime.minute) }} for {{ b.lengthInMin }} minutes
        <button
          class="cf-node__action m-l-5"
          @click="removeBreak(index)"
        >
          <i
            class="fa fa-trash"
            aria-hidden="true"
          />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';
import messages from '../../../../locales';

export default {
  name: 'HoursFilterBreaks',
  components: {
  },
  props: {
    breaks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    breakStartTime(hour, minute) {
      const time = `${moment(hour, 'H').format('HH')}:${moment(minute, 'm').format('mm')}`;
      return moment(time, 'HH:mm').format('LT');
    },
    removeBreak(index) {
      this.breaks.splice(index, 1);
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>